<div class="video-settings-container">
  <select class="spectrum-select camera-motion-select" 
          [(ngModel)]="settings.cameraMotion" 
          (ngModelChange)="onSettingChange()"
          [disabled]="disabled">
    <option *ngFor="let motion of cameraMotions" [value]="motion.value">
      {{ i18n.t(motion.label) }}
    </option>
  </select>
</div>